<template>
  <div class="card bg-light mb-3">
    <div class="card-header">
      <h5 class="card-title">
        <i class="fa fa-broadcast-tower"></i>
        {{ $t('CHANNEL_SETTINGS_STREAM_SETTINGS_TITLE') }}
      </h5>
    </div>
    <div class="card-body">
      <transition-group name="fade">
        <div class="row mt-2" v-for="(stream, index) in settings.streams" :key="'stream' + index">
          <div class="col-12">
            <div class="card">
              <div class="card-header bg-sidebar text-white">
                <div class="row">
                  <div class="col">
                    {{ $t('CHANNEL_SETTINGS_STREAM', {index: index + 1}) }}
                  </div>
                  <div class="col text-right">
                    <div class="badge badge-light" v-if="stream.isMain">{{ $t('CHANNEL_SETTINGS_STREAM_DEFAULT')
                      }}
                    </div>
                    <div class="badge badge-info pointer" v-else @click="setStreamAsDefault(stream)">{{
                      $t('CHANNEL_SETTINGS_STREAM_SET_DEFAULT') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <label :for="'server' + index">{{ $t('CHANNEL_SETTINGS_STREAM_SERVER') }}</label>
                    <input type="text" v-model="stream.server" placeholder="Server" class="form-control"
                           :id="'server' + index">
                  </div>

                  <div class="col-12 col-md-6">
                    <label :for="'application' + index">{{ $t('CHANNEL_SETTINGS_STREAM_APPLICATION')
                      }}</label>
                    <input type="text" v-model="stream.application" placeholder="Application" class="form-control"
                           :id="'application' + index">
                  </div>
                </div>

                <div class="row mt-1">
                  <div class="col">
                    <label :for="'stream' + index">{{ $t('CHANNEL_SETTINGS_STREAM_STREAM') }}</label>
                    <input type="text" v-model="stream.stream" placeholder="Stream" class="form-control"
                           :id="'application' + index">
                  </div>
                </div>

                <div class="row mt-2 text-right">
                  <div class="col">
                    <button class="btn text-danger" @click="removeStreamByIndex(index)">
                      <i class="fa fa-times"></i> {{ $t('CHANNEL_SETTINGS_REMOVE_STREAM') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition-group>

      <div class="row mt-2">
        <div class="col">
          <div class="card">
            <div class="card-body p-0">
              <button class="btn" @click="addEmptyStream">
                <i class="fa fa-plus"></i>
                {{ $t('CHANNEL_SETTINGS_ADD_STREAM') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../../../../repositories/RepositoryFactory';

const ChannelSettingsRepository = RepositoryFactory.get('channelSettings');

export default {
  name: 'StreamSettings',
  computed: {
	    settings() {
	    	return this.$store.getters.getChannelSettings;
    },
  },
  methods: {
    addEmptyStream() {
      this.settings.streams.push({
        application: '',
        isMain: false,
        server: '',
        stream: '',
      });
    },

    /**
       * Removes the given Stream
       */
    removeStreamByIndex(index) {
      this.settings.streams = this.settings.streams.filter((stream, sindex) => sindex !== index);
    },

    /**
			 * Sets a stream as the default.
			 *
			 * @param stream
			 */
    setStreamAsDefault(stream) {
      stream.isMain = true;
      this.settings.streams
        .filter(filteredStream => filteredStream !== stream)
        .forEach(singleStream => singleStream.isMain = false);
    },
  },
};
</script>
